import { useChangePasswordFlow } from 'modules/auth/flows/useChangePasswordFlow'
import { useChangePasswordForm } from 'modules/auth/hooks/useChangePasswordForm'
import { IconEmail } from 'modules/common/components/_icons/icons'
import { Button } from 'modules/common/components/_ui/Button/Button'
import { TextField } from 'modules/common/components/_ui/FormControl/TextField/TextField'
import { Message } from 'modules/common/components/_ui/Message/Message'
import { useTranslation } from 'modules/common/hooks/useTranslation'

interface Props {
  className?: string
}

export const ChangePasswordForm = ({ className }: Props) => {
  const { t } = useTranslation('auth-components')

  const { requestChangePassword, isLoading, requestFailed } =
    useChangePasswordFlow()

  const {
    control,
    handleSubmit,
    formState: { errors },
    register,
  } = useChangePasswordForm()

  return (
    <form
      onSubmit={handleSubmit((data) => requestChangePassword(data))}
      className={className}
    >
      <div>
        <TextField
          id="email"
          {...register('email')}
          label={t('fillChangePasswordForm.email.label')}
          leftDecorator={<IconEmail />}
          control={control}
          error={errors.email}
          isRequired
        />
        {requestFailed && (
          <Message
            title={t(
              'fillChangePasswordForm.errors.changePasswordRequest.title'
            )}
            content={t(
              'fillChangePasswordForm.errors.changePasswordRequest.content'
            )}
            type="error"
          />
        )}
        <div className="flex pt-4">
          <Button
            variant="primary"
            color="default"
            isLoading={isLoading}
            className="flex-1"
            type="submit"
          >
            {t('fillChangePasswordForm.submitLabel')}
          </Button>
        </div>
      </div>
    </form>
  )
}
